const mapErrors = {
  timeout: ['timeout', 'The request takes a long time'],
  backendDown: ['backendDown', 'El servidor no responde'],
  networkError: ['networkError', 'No hay conexión a internet'],
  badResponse: ['badResponse', 'Los datos recibidos no son los esperados'],
  badParams: ['badParams', 'Los datos enviados no son válidos'],
  userNotExist: ['userNotExist', 'No existe ningún usuario registrado con esos datos'],
  userNotConfirmed: ['userNotConfirmed', 'El usuario no ha confirmado su cuenta'],
  sessionClosed: ['sessionClosed', 'La sesión del usuario ha sido cerrada'],
  tokenNotFound: ['tokenNotFound', 'El refresh token ha caducado'],
  oauthUnlinked: ['oauthUnlinked', 'Error de autentificación con la cuenta de Nest'],
  401: ['sessionExpired', 'La sesión del usuario ha expirado'],
  403: ['sessionClosed', 'La sesión del usuario ha sido cerrada'],
  invalidDevice: ['invalidDevice', 'Error al validar los datos del dispositivo'],
  invalidInstallation: ['invalidInstallation', 'Error al validar los datos de la instalación'],
  invalidInstallations: ['invalidInstallations', 'Error al obtener las instalaciones'],
  invalidUser: ['invalidUser', 'Error al validar los datos del usuario'],
  invalidSchedule: ['invalidSchedule', 'Error al validar los datos de una programación'],
  invalidScene: ['invalidScene', 'Error al validar los datos de una escena'],
  bluetoothDisabled: ['bluetoothDisabled', 'El móvil no tiene activado el bluetooth'],
  LocationDisabled: ['LocationDisabled', 'El móvil no tiene activada la localización'],
  errorLocationEnabled: [
    'errorLocationEnabled',
    'Error al intentar comprobar si el móvil tiene activado la localización',
  ],
  LocationNotAvailable: ['LocationNotAvailable', 'El móvil no tien disponible la localización'],
  errorLocationAvailable: [
    'errorLocationAvailable',
    'Error al intentar comprobar si el móvil tiene la localización disponible',
  ],
  errorAskActiveLocation: [
    'errorAskActiveLocation',
    'Error al intentar preguntar al usuario que permita el uso de la localización',
  ],
  errorStartScan: ['errorStartScan', 'Error al intentar buscar webservers por bluetooth'],
  errorStopScan: ['errorStopScan', 'Error al intentar parar de buscar webservers por bluetooth'],
  disconnectDevice: ['disconnectDevice', 'El webserver se ha desconectado del bluetooth'],
  errorWriteDevice: ['errorWriteDevice', 'Error al intentar enviar datos al webserver'],
  errorStringToBytes: [
    'errorStringToBytes',
    'Error al intentar convertir una cadena de texto a bites',
  ],
  errorBytesToString: [
    'errorBytesToString',
    'Error al intentar convertir bites en una cadena de texto',
  ],
  errorReadDevice: ['errorReadDevice', 'Error al intentar obtener datos del webserver'],
  errorGetDeviceInfo: ['errorGetDeviceInfo', 'Error al intentar obtener información del webserver'],
  errorGetDeviceParams: [
    'errorGetDeviceParams',
    'Error al intentar obtener información de parámetros del webserver',
  ],
  errorSetDeviceParam: [
    'errorSetDeviceParam',
    'Error al intentar asignar parámetros del webserver',
  ],
  errorDisconnectDevice: ['errorDisconnectDevice', 'Error al intentar desconectarse del webserver'],
  deviceNotFound: ['deviceNotFound', 'El webserver no se encuentra aprovisionado'],
};

export default mapErrors;
